import useMakePageScrollable from '@hooks/useMakePageScrollable';
import DeviceListPage from '@src/components/_shared/devices/DeviceListPage';
import { Device } from '@src/types/Device';
import { DeviceType } from '@src/types/devices/DeviceConfig.types';
import storeConnector from '@store/storeConnector';

interface PCSProps {
  currentUnit: Device;
}

const PCS = ({ currentUnit }: PCSProps) => {
  useMakePageScrollable();
  return (
    <DeviceListPage currentUnit={currentUnit} deviceType={DeviceType.PCS} />
  );
};

export default storeConnector(PCS, {
  service: ['currentUnit'],
});
